import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PendingCredentialsProvider } from '../../../features/auth/login/pending-credentials-context';
import { getPageHead } from '../../../util/routing/meta';

export const Route = createFileRoute('/_auth/login/_login')({
  head: () => getPageHead('Sign In'),
  component: LoginLayout,
});

function LoginLayout() {
  return (
    <PendingCredentialsProvider>
      <Outlet />
    </PendingCredentialsProvider>
  );
}
